import React, { useEffect, useState } from "react"
import styles from "./pagarPlan.module.sass"
import { useHistory } from "react-router-dom"
import CurrencyFormat from "react-currency-format"

// import { getStatement, getStatementOtherCard } from 'services/Movements'

import { useToken } from 'hooks/useToken'
import { useIsMobile } from 'hooks/useIsMobile'
import { decodeStorage } from 'functions/storageBase64'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'


export function usePlanesPago() {

    // const refreshToken = useToken({ firstActive: false, name: "pagarPlanes" })
    // const [newToken, setNewToken] = useState(false)
    const history = useHistory()
    const { isMobile } = useIsMobile()

    const cardendingPayment = decodeStorage('cardendingPayment')
    const noInternetPayment = decodeStorage('noInternetPayment')
    const pagoExpress = decodeStorage('pagoExpress')
    const lastConsultData = decodeStorage('lastConsultData')
    const [errorCode, setErrorCode] = useState()

    // funciones para mostrar el modal
    const [showModal, SetShowModal] = useState(false)
    // const showModalErrorCode = () => SetShowModal(true)

    const singlePlanData = {}
    
    // console.log('pagoExpress: ',pagoExpress);
    // console.log('lastConsultData: ',lastConsultData);

    if (pagoExpress) {
        singlePlanData.cardending = pagoExpress?.cardending;
        singlePlanData.minimum_to_pay = pagoExpress?.minimum_to_pay;
        singlePlanData.monthly_payment = pagoExpress?.monthly_payment;
        singlePlanData.new_balance_cutting = pagoExpress?.new_balance_cutting;
        singlePlanData.payment_not_generate_interest = pagoExpress?.payment_not_generate_interest;
        singlePlanData.credit_imit = pagoExpress?.credit_imit;
    } else {
        singlePlanData.cardending = lastConsultData[0]?.cards[0]?.card_number.substr(-4);
        singlePlanData.minimum_to_pay = lastConsultData[0]?.minimum_to_pay;
        singlePlanData.monthly_payment = lastConsultData[0]?.monthly_payment;
        singlePlanData.new_balance_cutting = lastConsultData[0]?.new_balance_cutting;
        singlePlanData.payment_not_generate_interest = lastConsultData[0]?.payment_not_generate_interest;
        singlePlanData.credit_imit = lastConsultData[0]?.credit_imit;
    }

    // Recibe la respuesta y segmenta los planes
    const [completePlanData, setCompletePlanData] = useState([]);

    const handleClose = () => {
        SetShowModal(false);
        if (cardendingPayment) {
            if (completePlanData.length <= 0) {
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`);
            }
        } else if (noInternetPayment) {
            if (completePlanData.length <= 0) {
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}informacion-tarjeta-express`);
            }
        }
    }

    return {
        setErrorCode,
        handleClose,
        singlePlanData,
        completePlanData,
        showModal,
        errorCode,
        isMobile
    }
}


export function ContentSinglePlans(props){

    const {
        singlePlanData,
        isMobile
    } = props;

    const [otherValueSP, setOtherValueSP] = useState(singlePlanData.minimum_to_pay === 0 ?  singlePlanData.monthly_payment : singlePlanData.minimum_to_pay);
    const changeOtherValue = (e) => {
        let otherPl = e.target.value;
        let totalFloat;
        let regE = /[^\d\.\d+]+/g;
        let precioRedondo = otherPl.replace(regE, '');
        if (isNaN(precioRedondo)) {
            totalFloat = parseFloat(precioRedondo);
        } else {
            totalFloat = precioRedondo;
        }
        setOtherValueSP(totalFloat);
    }

    useEffect(() => {

        if (singlePlanData.minimum_to_pay !== 0) {
            if(document.querySelector(`.${styles?.contentCardsSimplePlan} input[type="radio"]`)){
                document.querySelector(`.${styles?.contentCardsSimplePlan} input[type="radio"]`).checked = true;
            }
        }
        if (singlePlanData.minimum_to_pay === 0 && singlePlanData.monthly_payment === 0 && singlePlanData.payment_not_generate_interest === 0) {
            if(document.querySelector(`.${styles?.contentCardsSimplePlan} input[id="new_balance_cutting_SP"]`)){
                document.querySelector(`.${styles?.contentCardsSimplePlan} input[id="new_balance_cutting_SP"]`).checked = true;
            }
        }
        if(singlePlanData.minimum_to_pay === 0 && singlePlanData.monthly_payment !== 0){
            if(document.querySelector(`.${styles?.contentCardsSimplePlan} input[id="monthly_payment_SP"]`)){
                document.querySelector(`.${styles?.contentCardsSimplePlan} input[id="monthly_payment_SP"]`).checked = true;
            }
        }
    }, [])

    const [isDisabled, setIsDisabled] = useState(true);
    const [viewInfo, setViewInfo] = useState(false);

    const formSimplePlan = () => {
        let selected = document.querySelector(`.${styles?.contentCardsSimplePlan} input[type="radio"]:checked`)?.id;

        if (selected === "other_pay_SP") {
            setIsDisabled(false);
            setViewInfo(true);
        } else {
            setIsDisabled(true);
            setViewInfo(false);
            setOtherValueSP(singlePlanData.minimum_to_pay === 0 ?  singlePlanData.monthly_payment : singlePlanData.minimum_to_pay);
        }
    }

    return (
        <>
            <form className={styles?.contentCardsSimplePlan} onChange={formSimplePlan}>
                
                {singlePlanData?.minimum_to_pay <= 0
                    ?
                        <div className={styles?.cardToPay}>
                            <label htmlFor="monthly_payment_SP">
                                <span>Mensualidad</span>
                                <CurrencyFormat
                                    value={Number(singlePlanData.monthly_payment % 1) === 0 ? singlePlanData.monthly_payment + '.001' : singlePlanData.monthly_payment}
                                    displayType={'text'}
                                    decimalScale={2}
                                    FixedDecimalScale={true}
                                    thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                                />
                            </label>
                            <input type="radio" id="monthly_payment_SP" name="singlePlan" value={singlePlanData.monthly_payment} data-terminal="17"
                                disabled={singlePlanData.monthly_payment === 0 ? true : false} />
                        </div>
                    :
                        <div className={styles?.cardToPay}>
                            <label htmlFor="minimum_to_pay_SP">
                                <span>Mensualidad</span>
                                <CurrencyFormat
                                    value={Number(singlePlanData.minimum_to_pay % 1) === 0 ? singlePlanData.minimum_to_pay + '.001' : singlePlanData.minimum_to_pay}
                                    displayType={'text'}
                                    decimalScale={2}
                                    FixedDecimalScale={true}
                                    thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                                />
                            </label>
                            <input type="radio" id="minimum_to_pay_SP" name="singlePlan" value={singlePlanData.minimum_to_pay} data-terminal="16"
                                disabled={singlePlanData.minimum_to_pay === 0 ? true : false} />
                        </div>
                }


                <div className={styles?.cardToPay}>
                    <label htmlFor="new_balance_cutting_SP">
                        <span>Pago para liquidar tu cuenta:</span>
                        <CurrencyFormat
                            value={Number(singlePlanData.new_balance_cutting % 1) === 0 ? singlePlanData.new_balance_cutting + '.001' : singlePlanData.new_balance_cutting}
                            displayType={'text'}
                            decimalScale={2}
                            FixedDecimalScale={true}
                            thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                        />
                    </label>
                    <input type="radio" id="new_balance_cutting_SP" name="singlePlan" value={singlePlanData.new_balance_cutting} data-terminal="18" />
                </div>


                <div className={styles?.cardToPaySingle}>
                    <label htmlFor="other_pay_SP">
                        <span>Otro monto</span>
                        <input type="text" value={otherValueSP} onChange={changeOtherValue} className="inputLine" disabled={isDisabled} placeholder="0" />

                        {viewInfo &&
                            <span className={styles?.infoMessag}></span>
                        }
                    </label>
                    <input type="radio" id="other_pay_SP" name="singlePlan" value={otherValueSP} data-terminal="19" />
                </div>

            </form>
        </>
    )
}


const ContPlanCardPay = (props) => {

    const {
        ind,
        plan_name,
        monthly_payment,
        balance_cutting,
        new_balance_cutting,
        minimum_payment,
        pay_plan,
        sequence,
        showInfoPlan,
        allChecked
    } = props;

    const [valuePlan, setValuePlan] = useState(monthly_payment);
    const [isDisabled, setIsDisabled] = useState(true);

    const changeValuePlan = (event) => {
        let pricePlan = event.target.value;
        let totalFloat;
        let regE = /[^\d\.\d+]+/g;
        let precioRedondo = pricePlan.replace(regE, '');
        if (isNaN(precioRedondo)) {
            totalFloat = parseFloat(precioRedondo);
        } else {
            totalFloat = precioRedondo;
        }
        setValuePlan(totalFloat);
    }

    const [resetPay, setResetPay] = useState(false);
    useEffect(() => {
        if (allChecked) {
            setIsDisabled(false);
        } else {
            setResetPay(true);
            setIsDisabled(true);
        }
    }, [allChecked])

    useEffect(() => {
        if (resetPay) {
            setValuePlan(monthly_payment);
            setResetPay(false);
        }
    }, [resetPay])

    const validateCheck = (event) => {
        let valid = event.target.checked;
        if (valid) {
            setIsDisabled(false);
        }
        else {
            setResetPay(true);
            setIsDisabled(true);
        }
    }

    return (
        <div className="cardPay">
            <div className="cardPaySup">
                <label className="topPlanName" htmlFor={`cardPaysegment_${ind}`}>
                    <input
                        type="checkbox"
                        name={plan_name}
                        value={valuePlan}
                        id={`cardPaysegment_${ind}`}
                        onChange={validateCheck}
                        data-sequence={sequence}
                        data-plan={pay_plan}
                    />
                    <p>{plan_name}</p>
                </label>
                <div>
                    <input type="text" value={valuePlan} onChange={changeValuePlan} className="inputLine" disabled={isDisabled} />
                </div>
                <div className="showCardInf" onClick={(inedex) => showInfoPlan(ind)} ></div>
            </div>
            <div className="cardPayInf">
                <div>
                    <p>Saldo actual</p>
                    <CurrencyFormat
                        value={Number(new_balance_cutting % 1) === 0 ? new_balance_cutting + '.001' : new_balance_cutting}
                        displayType={'text'}
                        decimalScale={2}
                        FixedDecimalScale={true}
                        thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                    />
                </div>
                <div>
                    <p>Saldo facturado</p>
                    <CurrencyFormat
                        value={Number(balance_cutting % 1) === 0 ? balance_cutting + '.001' : balance_cutting}
                        displayType={'text'}
                        decimalScale={2}
                        FixedDecimalScale={true}
                        thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                    />
                </div>
                <div>
                    <p>Pago mínimo</p>
                    <CurrencyFormat
                        value={Number(minimum_payment % 1) === 0 ? minimum_payment + '.001' : minimum_payment}
                        displayType={'text'}
                        decimalScale={2}
                        FixedDecimalScale={true}
                        thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                    />
                </div>
            </div>
        </div>

    )
}

export function ContentMultiplePlans(props){

    const {
        completePlanData,
        setTextPlan,
        setTotalPlansPay,
        setTotalArrayPlan,
        isMobile
    } = props

    useEffect(() => {
        setTextPlan("0 planes")
    }, [])

    const [buttonActive, setButtonActive] = useState(false)
    const [planSeleccionad, setPlanSeleccionad] = useState()
    const [planPos, setPlanPos] = useState()
    const [selAll, setSellAll] = useState(false)

    // selecciona todos los planes
    const seleccionarTodos = () => {
        let checkPlan = document.querySelectorAll('.contentCardsMultiPlan .cardPaySup')
        let inicio
        let planPosition = []
        for (inicio = 0; inicio <= (checkPlan.length - 1); inicio++) {
            document.querySelectorAll(`.contentCardsMultiPlan  .cardPaySup .topPlanName input`)[inicio].checked = true
            planPosition.push(inicio)
        }
        setButtonActive(1)
        setPlanPos(planPosition)
        setPlanSeleccionad()
        setSellAll(true)
        changePlan()
        setTextPlan(`${checkPlan.length} planes`)
    };

    // deselecciona todos los planes
    const deseleccionarTodos = () => {
        let checkPlan = document.querySelectorAll('.contentCardsMultiPlan .cardPaySup')
        let inicio
        let planPosition = []
        for (inicio = 0; inicio <= (checkPlan.length - 1); inicio++) {
            document.querySelectorAll(`.contentCardsMultiPlan  .cardPaySup .topPlanName input`)[inicio].checked = false
        }
        setButtonActive(0)
        setPlanPos([])
        setPlanSeleccionad([])
        setSellAll(false)
        setTotalPlansPay(0)
        setTextPlan("0 planes")
    };

    // mostrar info por plan
    const [lastslect, setLastSelect] = useState()
    const showInfoPlan = (index) => {
        let pos = index
        setLastSelect(pos)
        if (lastslect != pos) {
            if (document.querySelectorAll('.contentCardsMultiPlan .cardPay.showInfoPlan').length >= 1) {
                let i
                for (i = 0; i <= document.querySelectorAll('.contentCardsMultiPlan .cardPay.showInfoPlan').length; i++) {
                    document.querySelectorAll('.contentCardsMultiPlan .cardPay.showInfoPlan')[0].classList.remove('showInfoPlan')
                }
            }
            document.querySelectorAll('.contentCardsMultiPlan .cardPay')[pos].classList.add('showInfoPlan')
        } else {
            document.querySelectorAll('.contentCardsMultiPlan .cardPay')[pos].classList.toggle('showInfoPlan')
        }
    }


    // cambiar plan
    const changePlan = () => {
        let checked = document.querySelectorAll(`.contentCardsMultiPlan  .cardPaySup .topPlanName input:checked`)
        let valorMultiPlan = document.querySelectorAll('.contentCardsMultiPlan .cardPay input[type="checkbox"]:checked')

        if (checked?.length === 1) {
            setTextPlan(`1 plan`)
        } else if (checked?.length >= 2) {
            setTextPlan(`${checked?.length} planes`)
        } else {
            setTextPlan(`0 planes`)
        }

        setTimeout(function () {
            if (valorMultiPlan?.length >= 1) {
                let sel = valorMultiPlan.length
                let cont
                let totalPayArray = []
                let totalPlanArray = []

                for (cont = 0; cont <= (sel - 1); cont++) {
                    totalPayArray.push(Number(valorMultiPlan[cont].value))
                    totalPlanArray.push({
                        plan: Number(valorMultiPlan[cont].dataset.plan),
                        sequence: Number(valorMultiPlan[cont].dataset.sequence),
                        amount: Number(valorMultiPlan[cont].value)
                    })
                }
                setTotalPlansPay(sumarTotal(totalPayArray))

                setTotalArrayPlan(totalPlanArray.filter(val => val.amount != 0))
                // console.log(':::: ',totalPlanArray.filter(val => val.amount != 0 ))
            }
            else {
                setTotalPlansPay(0)
                setTotalArrayPlan([])
            }
        }, 100)
    }

    const sumarTotal = (totalPayArray) => {
        let totalPagar
        totalPagar = totalPayArray.reduce((a, b) => a + b, 0)

        return totalPagar
    }

    return (
        <>
            <div className="linkSeleccionarTodos">
                {selAll
                    ? <p onClick={deseleccionarTodos}>Deseleccionar todo</p>
                    : <p onClick={seleccionarTodos}>Seleccionar todo</p>
                }
            </div>

            <form className={isMobile === "desktop" ? "contentCardsMultiPlan" : "contentCardsMultiPlan"} onChange={changePlan}>
                {completePlanData && completePlanData.map((payPlans, ind) =>

                    <ContPlanCardPay
                        key={ind}
                        ind={ind}
                        plan_name={payPlans.plan_name}
                        monthly_payment={payPlans.monthly_payment}
                        balance_cutting={payPlans.balance_cutting}
                        new_balance_cutting={payPlans.new_balance_cutting}
                        minimum_payment={payPlans.minimum_payment}
                        sequence={payPlans.sequence}
                        pay_plan={payPlans.pay_plan}
                        showInfoPlan={showInfoPlan}
                        allChecked={selAll}
                    />
                )
                }
            </form>
        </>
    )
}

export function CardPlanPagar() {

    const planAsignado = decodeStorage('payCardRelation')

    return(
        <div className={styles?.cardPago}>
            Total a pagar: 
            <CurrencyFormat
                value={Number(planAsignado?.totalToPay % 1) === 0 ? planAsignado?.totalToPay + '.001' : planAsignado?.totalToPay}
                displayType={'text'}
                decimalScale={2}
                FixedDecimalScale={true}
                thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
            />
        </div>
    )
}